'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = formDatetime;

var _formDate = require('./formDate');

var _formDate2 = _interopRequireDefault(_formDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formDatetime(props) {
  return (0, _formDate2.default)((0, _extends3.default)({}, props, { timeFormat: 'HH:mm', closeOnSelect: false }));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/formDatetime.js
// module id = 2135
// module chunks = 1